import { AutocompleteRoot } from "./Autocomplete.styles";
import AutocompleteInput from "./AutocompleteInput/AutocompleteInput";
import clsx from "clsx";
import useAutocomplete from "./hooks/useAutocomplete";
import { AutocompleteProps } from "./Autocomplete.types";

function Autocomplete<T>({
    className,
    size = "lg",
    defaultValue,
    value,
    onChange,
    options,
    defaultSearch = "",
    search: searchProp,
    onSearchChange,
    isLoading,
    name,
    required,
    readonly,
    nothingToShow,
    loadingText,
    placeholder,
    ...rest
}: AutocompleteProps<T>) {
    const { selectProps, inputProps } = useAutocomplete<T>({
        defaultSearch,
        search: searchProp,
        onSearchChange,
        defaultValue,
        value,
        onChange,
        options,
        isLoading,
        name,
        required,
        loadingText,
        nothingToShow,
    });

    return (
        <AutocompleteRoot
            {...selectProps}
            required={required}
            readonly={readonly}
            placeholder={placeholder}
            dropdownElement={<></>}
            className={clsx("autocomplete", className)}
            renderValue={() => <AutocompleteInput placeholder={placeholder} readonly={readonly} {...inputProps} size={size} />}
            size={size}
            {...rest}
        />
    );
}

export default Autocomplete;
